// extracted by mini-css-extract-plugin
export default {"body":"styles_body__7vVcY","content":"styles_content__PgNJo","info":"styles_info__ioLB6","buttonText":"styles_buttonText__cRlWh"};